module.exports = __webpack_public_path__ + "img/square.4948258f.svg";